function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497 497",
    style: {
      enableBackground: "new 0 0 497 497"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", null, React.createElement("ellipse", {
    style: {
      fill: "#F0EEF0"
    },
    cx: 248.5,
    cy: 149.209,
    rx: 248.5,
    ry: 149.174
  }), React.createElement("path", {
    style: {
      fill: "#DFDDE0"
    },
    d: "M248.5,0.035c-8.439,0-16.778,0.255-25,0.748C349.002,8.31,447,71.888,447,149.209   s-97.998,140.9-223.5,148.426c8.222,0.493,16.561,0.748,25,0.748c137.243,0,248.5-66.788,248.5-149.175S385.743,0.035,248.5,0.035z   "
  }), React.createElement("path", {
    style: {
      fill: "#FFE4C2"
    },
    d: "M306.983,324.177c0,32.552-26.399,58.941-58.954,58.941c-32.565,0-58.965-26.389-58.965-58.941   c0-32.552,26.399-58.936,58.965-58.936C280.584,265.241,306.983,291.625,306.983,324.177z"
  }), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#C3DDFF"
    },
    d: "M189.35,496.965c-3.021-51.207-41.545-96.34-94.938-96.34c-55.022,0-87.3,41.317-93.762,90.431       c-0.412,3.135,2.065,5.909,5.227,5.909H189.35"
  })))), React.createElement("path", {
    style: {
      fill: "#A4CCFF"
    },
    d: "M94.411,400.625c-7.245,0-14.092,0.723-20.541,2.079c43.09,9.409,72.839,49.515,75.48,94.261h40    C186.328,445.758,147.805,400.625,94.411,400.625z"
  }), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B3E59F"
    },
    d: "M490.353,496.965c3.643,0,6.473-3.188,6.034-6.804c-5.87-48.334-43.31-89.535-94.325-89.535       c-54.631,0-86.839,40.731-93.62,89.384c-0.511,3.669,2.306,6.956,6.01,6.956H490.353z"
  })))), React.createElement("path", {
    style: {
      fill: "#95D6A4"
    },
    d: "M496.387,490.161c-5.87-48.334-43.31-89.536-94.325-89.536c-7.25,0-14.1,0.724-20.553,2.082    c40.899,8.926,69.783,45.499,74.878,87.454c0.439,3.616-2.391,6.804-6.034,6.804h40    C493.996,496.965,496.826,493.777,496.387,490.161z"
  }), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FF8086"
    },
    d: "M353.772,496.965c3.685,0,6.551-3.209,6.14-6.871c-6.472-57.635-50.917-107.003-111.629-107.003       c-65.083,0-103.243,48.906-110.842,107.014c-0.475,3.629,2.316,6.859,5.975,6.859H353.772z"
  })))), React.createElement("path", {
    style: {
      fill: "#E5646E"
    },
    d: "M359.912,490.094c-6.472-57.635-50.917-107.003-111.629-107.003c-7.191,0-14.052,0.599-20.58,1.74    c50.612,9.226,86.449,53.969,92.209,105.263c0.411,3.662-2.455,6.871-6.14,6.871h40    C357.457,496.965,360.323,493.756,359.912,490.094z"
  }), React.createElement("circle", {
    style: {
      fill: "#FFE4C2"
    },
    cx: 401.817,
    cy: 350.778,
    r: 49.856
  }), React.createElement("path", {
    style: {
      fill: "#C3DDFF"
    },
    d: "M94.855,400.631c-0.148-0.001-0.295-0.006-0.444-0.006c-0.25,0-0.496,0.007-0.745,0.009"
  }), React.createElement("path", {
    style: {
      fill: "#FFD064"
    },
    d: "M444.693,325.26c-8.707-14.574-24.635-24.338-42.846-24.338c-29.206,0-52.651,26.177-49.606,55.131    C353.906,356.381,412.095,367.502,444.693,325.26z"
  }), React.createElement("path", {
    style: {
      fill: "#857E87"
    },
    d: "M119.782,181.045l-9.287,16.226l11.433,12.367l16.908-7.979l18.633,9.067l4.908,18.039l16.83,0.662    l6.314-17.595l19.588-6.761l16.229,9.285l12.371-11.43l-7.981-16.903l9.069-18.629l18.043-4.907l0.664-16.825l-17.6-6.311    l-6.764-19.583l9.287-16.224l-11.432-12.367l-16.909,7.979l-18.635-9.068l-4.907-18.037l-16.83-0.663L163.4,88.981l-19.588,6.761    l-16.229-9.283l-12.37,11.428l7.98,16.903l-9.069,18.629l-18.042,4.907l-0.663,16.825l17.6,6.311L119.782,181.045z     M153.488,127.717c12.534-11.58,32.085-10.81,43.668,1.721c11.585,12.53,10.813,32.076-1.721,43.655    c-12.534,11.581-32.086,10.81-43.669-1.72C140.184,158.842,140.954,139.298,153.488,127.717z"
  }), React.createElement("path", {
    style: {
      fill: "#FF8086"
    },
    d: "M275.925,182.117l6.908,17.019l20.331-1.641l15.714,10.291l3.391,20.106l18.198,2.53l8.743-18.422    l16.772-8.46l19.113,7.118l11.291-14.492l-11.586-16.779l1.058-18.753l15.722-12.988l-6.906-17.019l-20.329,1.641l-15.716-10.292    l-3.389-20.106l-18.198-2.529l-8.744,18.422l-16.772,8.459l-19.115-7.116l-11.29,14.491l11.586,16.78l-1.058,18.751    L275.925,182.117z M321.203,151.216c7.551-9.689,21.527-11.427,31.219-3.881c9.693,7.546,11.429,21.521,3.881,31.21    c-7.549,9.69-21.526,11.428-31.218,3.881C315.392,174.88,313.654,160.907,321.203,151.216z"
  }), React.createElement("path", {
    style: {
      fill: "#E2A975"
    },
    d: "M301.046,298.384c-9.571-19.622-29.714-33.143-53.016-33.143c-36.285,0-64.54,33.865-57.978,69.632    l58.449-27.355l57.653,26.479C308.178,321.935,306.41,309.383,301.046,298.384z"
  }), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#FFE4C2"
    },
    cx: 94.977,
    cy: 350.778,
    r: 49.856
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#857E87"
    },
    d: "M94.979,300.921c-24.73,0-45.243,18.009-49.168,41.625l98.332-0.023      C140.208,318.919,119.701,300.921,94.979,300.921z"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.fdab1136.svg";
export { ForwardRef as ReactComponent };